import React from 'react';

function CheckboxIcon(props) {
	return (
		<svg className='eagerlyicon' xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
			<rect className='checkbox__outer' x="0.5" y="0.5" width="14" height="14" rx="2.5" stroke="#D9D9D9" />
			<rect className='checkbox__inner' x="4" y="4" width="7" height="7" rx="2" fill="#D9D9D9" />
		</svg>
	);
}

export default CheckboxIcon;
